import { useMemo } from 'react';
import { useGewerkeInfiniteQuery } from '../../../entities/gewerk';

/**
 * Gewerk id → name, for the trade chips on the technician cards. The same 500-item lookup the user
 * management list uses, so its cache entry is shared; the list is small and changes rarely.
 */
export function useGewerkLabels(): ReadonlyMap<number, string> {
  const { data } = useGewerkeInfiniteQuery({ limit: 500 });

  return useMemo(() => new Map((data?.items ?? []).map((g) => [g.id, g.text])), [data]);
}
